<template>
  <div>
    <donut-page-sections-two-column title="Participants" :description="description">
      <template #right-side>
        <div v-if="hrisCategories">
          <integrations-recipients-rule-accordion
            network-method="put"
            update-path="/shoutouts/settings"
            update-args-key="shoutouts_program"
            :hris-categories="hrisCategories"
            :things-text="`Allow sending ${shoutoutsNoun} to`"
            :not-eligible-text="`to receive ${shoutoutsFeature}`"
          />
        </div>
        <div v-else>
          <a class="button inv m-tx1" href="/hris">Connect HRIS</a>
        </div>
      </template>
    </donut-page-sections-two-column>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue';
import { useStore } from 'vuex';

const $i18n = inject('$i18n');
const { state } = useStore();

const shoutoutsNoun = $i18n.t('shoutouts.shoutout', { count: 2 });
const shoutoutsFeature = $i18n.t('shoutouts.feature', { count: 2 });

const hrisCategories = computed(() => state.hrisRecipientsRuleSelector.hrisCategories);

const description = computed(() => {
  if (hrisCategories.value) {
    return `Select who is eligible to use ${shoutoutsFeature} to give and receive peer-to-peer recognition points.`;
  }
  return `Connect your HRIS to manage which role types in your organization are eligible to use ${shoutoutsFeature} for peer-to-peer recognition.`;
});
</script>
